import React from 'react';
import { Portal } from '../../components/portal/Portal';
import { AttachMyCartBlock } from '../../templates/components/attachMyCartBlock/AttachMyCartBlock';
import { useCartContext } from '../../utils/cart/context/CartContext';
import { fetchServiceSuggestions } from '../../templates/components/pdp/utils/product-service';
import { useQuery } from 'react-query';
import { LineItemProps } from '@jbhi-fi/apis/src/services/types';

export const CartAttach = () => {
  const { cart } = useCartContext();
  const variants = (
    cart?.items?.map(lineItem => {
      const sku = parseInt(lineItem?.sku);
      return !isNaN(sku) && !lineItem.properties._marketplaceSellerId
        ? { Sku: sku, DisplayPriceInc: lineItem?.final_line_price / 100 }
        : null;
    }) ?? []
  ).filter(Boolean) as Array<{ Sku: number; DisplayPriceInc: number }>;

  const { data: serviceSuggestions = [], isLoading: isServicesLoading } = useQuery({
    queryKey: ['serviceSuggestions', variants],
    queryFn: () => (variants ? fetchServiceSuggestions(variants) : undefined),
    enabled: variants?.length > 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return (
    <>
      {cart?.items?.map((lineItem, i) => {
        const container = window.document.getElementById(`attach-${lineItem.line_id}`);
        const filteredServiceSuggestions = (serviceSuggestions as Array<LineItemProps>)?.filter(
          suggestion =>
            suggestion.productSku === lineItem.sku &&
            suggestion.finalProductPriceInc === lineItem.final_line_price / 100 &&
            suggestion.services?.length
        );
        if (container && lineItem?.sku) {
          return (
            <Portal key={i} container={container}>
              <AttachMyCartBlock
                purchasedProductSku={lineItem.sku}
                serviceSuggestions={filteredServiceSuggestions}
                isServicesLoading={isServicesLoading}
                cartProduct={lineItem}
              />
            </Portal>
          );
        }
      })}
    </>
  );
};
